import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { Reveal, Eyebrow } from "@/components/Motion";
import { INDUSTRIES, img } from "@/lib/content";

const Industries = () => (
  <>
    <Seo
      title="Industries — NEXREQ UAE & GCC"
      siteName="NEXREQ"
      description="Sector-specialized recruitment across banking, technology, real estate, energy, healthcare, legal, logistics and professional services in the GCC."
    />
    <PageHero
      eyebrow="Industries"
      lines={["Specialists, Not", "Generalists."]}
      description="Our consultants recruit inside the sectors they know deeply — so shortlists reflect the market, not a database."
      image={img("photo-1493397212122-2b85dda8106b", 1920)}
    />

    <section className="bg-obsidian py-24 lg:py-32" data-testid="industries-list">
      <div className="nx-container space-y-20">
        {INDUSTRIES.map((ind, i) => (
          <div
            key={ind.name}
            className="grid gap-10 border-t border-white/10 pt-12 lg:grid-cols-12 lg:items-center"
            data-testid={`industry-chapter-${i}`}
          >
            <Reveal className={`lg:col-span-5 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
              <div className="overflow-hidden">
                <img
                  src={img(ind.image, 1200)}
                  alt={ind.name}
                  className="aspect-[16/10] w-full object-cover grayscale-[30%] transition duration-700 hover:grayscale-0"
                  loading="lazy"
                />
              </div>
            </Reveal>
            <div className={`lg:col-span-7 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
              <span className="font-mono text-xs tracking-[0.3em] text-emerald-500">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h2 className="mt-4 font-heading text-2xl font-light tracking-tight text-white sm:text-3xl">
                {ind.name}
              </h2>
              <p className="mt-4 max-w-xl leading-relaxed text-white/55">{ind.blurb}</p>
              <Link
                to="/jobs"
                className="mt-6 inline-flex items-center gap-2 text-sm text-emerald-400 transition-colors hover:text-emerald-300"
                data-testid={`industry-jobs-link-${i}`}
              >
                View related opportunities <ArrowRight size={14} />
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>

    <section className="border-t border-white/[0.08] bg-surface py-24" data-testid="industries-cta">
      <div className="nx-container grid gap-10 lg:grid-cols-[2fr_1fr] lg:items-end">
        <div>
          <Reveal>
            <Eyebrow>Your Sector. Your Search.</Eyebrow>
          </Reveal>
          <h2 className="mt-6 font-heading text-3xl font-light tracking-tight text-white sm:text-4xl">
            Speak With a Sector Specialist.
          </h2>
        </div>
        <Reveal delay={0.2} className="lg:justify-self-end">
          <Link to="/hire-talent" className="nx-btn-primary" data-testid="industries-hire-btn">
            Start a Conversation <ArrowRight size={15} />
          </Link>
        </Reveal>
      </div>
    </section>
  </>
);

export default Industries;
